import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import usePortalService from "../../services/PortalService";
import { FileDragDropInputField } from "./FileDragDropInputField";
import {Row} from "antd";
import { DeletableCertificate } from "./DeletableCertificate";
import { Diploma } from "../../types";
import { MAX_REQUEST_DATA_SIZE } from "../../Consts/HttpRequests";
import { SizeError } from "../../Classes/Errors/SizeError";

type PdfInputProps = {
  filesInit?: Diploma[] 
}

function PdfInput({filesInit}: PdfInputProps, ref: any) {

    const {uploadCertificates, deleteCertificates} = usePortalService();

    const [files, setFiles] = useState<Diploma[]>([]);
    const [filesToUpload, setFilesToUpload] = useState<Diploma[]>([]);
    const [filesToDelete, setFilesToDelete] = useState<Diploma[]>([]);

    useEffect(() => {
      if (filesInit) {
        const initArray = []
        for (let i = 0; i < filesInit.length; i++) {
          initArray.push({
            id : filesInit[i].id,
            isOnServer : true,
            name : filesInit[i].name,
            length : filesInit[i].length
          })
        }
        setFiles(initArray);
      }
    }, [filesInit])

    const handlefFilesChange = (fileList: FileList) => {
      const initArray = [];
  
      for (let i = 0; i < fileList.length; i++){
        initArray.push({
          id : fileList[i].name,
          isOnServer : false,
          file : fileList[i],
          name : fileList[i].name,
          length : fileList[i].size + ' Б'
        })
      }
      setFilesToUpload([
        ...filesToUpload,
        ...initArray
      ])
      setFiles([
        ...files,
        ...initArray
      ]);
    };

    const deleteFile = (id: string) => {
      if (filesToUpload.findIndex(file => file.id === id) !== -1) {
        setFilesToUpload(filesToUpload.filter(file => file.id !== id));
      } else {
        setFilesToDelete([
          ...filesToDelete,
          files.find(file => file.id === id)!
        ])
      }
      setFiles(files.filter(file => file.id !== id));
    }
  
    const uploadHandle = async () => {
      if (filesToUpload.length !== 0) {
        const data = new FormData();
        let dataFilesSize = 0
        for (let i = 0; i < filesToUpload.length; i++) {
          dataFilesSize += filesToUpload[i]?.file?.size || 0;
          data.append(`Certificates`, filesToUpload[i].file!, filesToUpload[i]?.file?.name);
        }
        if (dataFilesSize >= MAX_REQUEST_DATA_SIZE) {
            throw new SizeError("Content is too large");
        }
        else {
            await uploadCertificates(data);
        }
      }
      if (filesToDelete.length) {
        const imagesIds = filesToDelete.map(item => (
            item.id
        ))
        await deleteCertificates({
          imagesIds
        })
      }
    };

    useImperativeHandle(ref, () => ({ save: uploadHandle }));
    
    return (
      <>
        <FileDragDropInputField handleFile={(file) => handlefFilesChange(file)} accept="application/pdf"/>
        <div>
          <Row justify="start">
            {files.map(diploma => 
              <DeletableCertificate 
                diploma={diploma} 
                deleteFromList={() => deleteFile(diploma.id)} 
                key={diploma.id}
              />
            )}
          </Row>
        </div>
      </>
    )
}

export default forwardRef(PdfInput);